import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-container-web dv-main-login" }
const _hoisted_2 = { class: "dv-container-form" }

import { ref, onMounted } from 'vue';
import { useServicesFactoryStore } from '@/core/stores/services-factory-store';
import LoginFormComponent from './LoginFormComponent.vue';
import LoginService from '@/core/services/login/LoginService';
import { ISesionApp } from '@/core/model/sesion/ISesionApp';
import { eAppPaths, eRolAppUsuario } from '@/core/model/GloblasEnum';
import { useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginComponent',
  setup(__props) {

const route = useRouter();
const loading = ref(false);
let serverResponse = ref({tipo:0,msg:''});
const loginService:LoginService = useServicesFactoryStore().getLoginService;
const evalServerResponse = (d:any)=>
{
  serverResponse.value = d;
}
const fnOnLogin = async (values:any) =>
{
    loading.value = true;  
    if(values)
    {
     serverResponse.value.tipo = 0;   
     serverResponse.value.msg = '';      
     const sesion:ISesionApp|null = await loginService.LoginEmployee(values,evalServerResponse);     
     if(sesion != null && sesion.Gid)
     {
      
       const sesionSaved = await loginService.SesionEmpleado(sesion);
       if(sesionSaved)
       {
        sendToHome(sesionSaved);
       }
     }
    }
    loading.value = false;  
};
const sendToHome = (sesion: ISesionApp) =>
{
  if(sesion && sesion.getId() && sesion.Type === eRolAppUsuario.Empleado) 
  {    
    route.replace({ name: eAppPaths.homeEmpleado });
  } 
  if(sesion && sesion.getId() && sesion.Type === eRolAppUsuario.Cliente) 
  {    
    route.replace({ name: eAppPaths.homeCliente });
  } 
};
onMounted(async ()=>
{        
  const sesion:ISesionApp|null = await loginService.getSession();   
  if(sesion)
  {           
    sendToHome(sesion);        
  }  
}); 

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(LoginFormComponent, {
        type: 1,
        serverResponse: _unref(serverResponse),
        loading: loading.value,
        class: "container-form",
        onOnLogin: fnOnLogin
      }, null, 8, ["serverResponse", "loading"])
    ])
  ]))
}
}

})